import cssLoader from "flow/utils/cssLoader";

cssLoader.load("dist/styles/fullcalendar.css");
